import { useEffect, useState } from "react";

export default function LogoMksp() {
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    const html = document.documentElement;
    const observer = new MutationObserver(() => {
      setIsDark(html.classList.contains("dark"));
    });

    observer.observe(html, { attributes: true, attributeFilter: ["class"] });

    setIsDark(html.classList.contains("dark"));

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <a
        href="/"
        className="text-2xl  text-green-700  px-1 font-extrabold text-primary flex items-center  whitespace-nowrap"
      >
        <img
          src={isDark ? "/img/v2/logoW.png " : "/img/v2/logoB.png"}
          alt="mksp"
          className="h-7 w-auto transition-all duration-300"
        />
      </a>
    </>
  );
}
